import {api} from '../api'

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    userOtpResetPassword: build.query({
      query(payload) {
        return {
          url: `/otp/check_reset_password/`,
          method: 'POST',
          data: {
            username: payload.username,
            code: payload.code,
          },
        }
      },
    }),


    createUserMerchantPermission: build.query({
      query(payload) {
        return {
          url: `/user-merchant-permission/`,
          method: 'POST',
          data: payload,
        }
      },
    }),

    updateUserMerchantPermission: build.query({
      query(payload) {
        return {
          url: `/user-merchant-permission/${payload?.id}/`,
          method: 'PUT',
          data: payload,
        }
      },
    }),

    regTokenCheck: build.query({
      query(payload) {
        return {
          url: `/user-registration-token/check/`,
          method: 'POST',
          data: payload,
        }
      },
    }),


    userOrderGainAccess: build.query({
      query(payload) {
        return {
          url: `/user-order/gain_access/`,
          method: 'POST',
          data: payload,
        }
      },
    }),
  }),
})
